export enum ModalActions {
  CONFIRM_ACTION = 'ACTION',
  CONFIRM_MESSAGE = 'MESSAGE',
}
